import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
	ViewChild,
	HostListener
} from '@angular/core';
import { RuleCommentModel, RuleModel, RuleStipModel } from './model/rule.model';
import {
	ORDER_STATE,
	RULE_MESSAGE_TYPE,
	RULE_STATUS,
	RULES_INDICATOR,
	VIEW_COMMENTS_MODE
} from './model/constants';
import {
	BroadcastService,
	BroadcastEventModel,
	ORDER_EVENT_TYPE,
	SignalRState,
	SubContent,
	ChangeEventItemOnChannelAction
} from '@cv-invision/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DOCUMENT_RULES_UI_SECTIONS } from '../model/quality.constant';
import { RuleService } from './service/rule.service';
import { Store } from '@ngxs/store';
import { RULE_SET_EVENT } from './rule-set/rule-set.component';
import { Observable, Subject, of } from 'rxjs';
import {
	SetIsRunningRules,
	UpdatedRuleStatus,
	DeleteComementRule,
	DeleteStipsRule,
	UpdatedRuleOrders,
	UpdatedMultipleRuleStatus,
	RuleComapateInfo,
	UpdatedRuleViolation,
	UpdatedRulelog,
	SetUncheckedRules,
	AddSrrRules,
	SetRuleSet
} from './state/action/rules.actions';
import { takeUntil } from 'rxjs/operators';
import { RulesState } from './state/rules.state';
import { QualityState } from '../state/quality.state';
import { OrderDetailModel } from '../state/model/order-detail.model';

import { CREATED_RULE_EVENT } from './../photo-review/photo-card/photo-card.component';

import { RuleStateModel } from './state/model/rules-state.model';
import { UPDATE_REJECTED_SUMMARY } from '../overview/sub-header/approve-reject-buttons/model/approve-reject-buttons.model';

enum TRANSITION_STATE {
	IS_OPEN = 'isOpen',
	IS_CLOSE = 'isClose'
}

enum SUB_PANEL_TYPE {
	CREATE_RULE = 'create_rule',
	ADD_COMMENT = 'add_comment',
	VIEW_COMMENTS_AND_STIPS = 'view_comments_and_stips',
	ADD_STIP = 'add_stip',
	VIEW_RULE_NOTIFICATIONS = 'view_rule_notifications'
}

export const UI_FIELD_SELECTED_EVENT = 'UI Field Selected';

@Component({
	selector: 'cv-rules',
	templateUrl: './rules.component.html',
	styleUrls: ['./rules.component.scss'],
	animations: [
		trigger('sideExpansion', [
			state('isOpen', style({ marginLeft: '10px' })),
			state('isClose', style({ marginLeft: '104%' })),
			transition(`isOpen <=> isClose`, animate('300ms'))
		])
	]
})
export class RulesComponent extends SubContent implements OnInit, OnDestroy {
	orderDetail$: Observable<OrderDetailModel> = this.store.select(QualityState.getOrderDetail);
	rules$: Observable<RuleStateModel> = this.store.select(s => s.quality.rules);
	rulesSelected$: Observable<any> = this.store.select(s => s.quality.rules.ordersRules);
	isRuleRunning$: Observable<boolean> = this.store.select(s => s.quality.rules.isRunningRules);
	onRevised$: Observable<boolean> = this.store.select(s => s.quality.rules.onRevised);
	channels$: Observable<any> = this.store.select(SignalRState.channelEvents);
	selectedSection$: Observable<any> = this.store.select(QualityState.getSelectedSection);

	@Input() data: {
		rules?: Array<RuleModel>;
		uiSection: DOCUMENT_RULES_UI_SECTIONS;
		targets: {
			data: Array<string>;
			primary: Array<string>;
		};
	};
	@Output() updateEvent: EventEmitter<any> = new EventEmitter<any>();
	@Output() successEvent: EventEmitter<any> = new EventEmitter<any>();
	@Output() errorEvent: EventEmitter<any> = new EventEmitter<any>();
	@Output() notificationEvent: EventEmitter<any> = new EventEmitter<any>();
	public rules: Array<RuleModel> = [];
	@ViewChild('rulesContainer', { static: true }) rulesContainer: ElementRef<any>;

	protected currentFilters: Array<RULE_MESSAGE_TYPE> = [
		RULE_MESSAGE_TYPE.Info,
		RULE_MESSAGE_TYPE.Warning,
		RULE_MESSAGE_TYPE.Error
	];

	filterOptions = [];
	filterValues = [];

	rulesInfo: number;
	rulesWarning: number;
	rulesError: number;
	rulesNotifications: Array<any>;
	runningRules: boolean;
	viewOnlyUncheckedRules: boolean;
	viewOnlySsrRules: boolean;
	canFilterSsr: boolean;

	selectedRule: RuleModel;
	subPanelSelectedRule: RuleModel;
	public currentTransitionState: TRANSITION_STATE;
	public TRANSITION_STATE = TRANSITION_STATE;
	public RULE_MESSAGE_TYPE = RULE_MESSAGE_TYPE;
	public SUB_PANEL_TYPE = SUB_PANEL_TYPE;
	public activeSubPanel: SUB_PANEL_TYPE;
	protected DOCUMENT_RULES_UI_SECTIONS = DOCUMENT_RULES_UI_SECTIONS;
	viewCommentsMode: VIEW_COMMENTS_MODE;
	orderInboxModel: any;
	currentUser: any;
	ORDER_STATE = ORDER_STATE;
	deferredRuleIndicator: string;
	previousOrderId: number;
	hasOrderBeenChanged: boolean;
	public updateRulesFunctionId: any;
	public updatedRuleStatus: Array<any>;

	/**
	 * Disable all possible rule action buttons when order is on this states below.
	 */
	get disableActionButtons(): boolean {
		if (!this.orderInboxModel) {
			return true;
		}

		return (
			this.orderInboxModel.stateEnum === ORDER_STATE.REJECTED ||
			this.orderInboxModel.stateEnum === ORDER_STATE.APPROVED ||
			this.orderInboxModel.stateEnum === ORDER_STATE.CANCELLED ||
			(this.orderInboxModel.lockedBy?.id !== this.currentUser.id)
		);
	}

	private currentSection: string;
	private atComponentDestroy = new Subject();

	constructor(
		broadcastService: BroadcastService,
		private rulesService: RuleService,
		private store: Store
	) {
		super(broadcastService);
		this.currentSection = null;
		this.currentTransitionState = TRANSITION_STATE.IS_CLOSE;
		this.viewOnlyUncheckedRules = this.store.selectSnapshot(RulesState.getUnchekedRules);
		this.rulesInfo = 0;
		this.rulesError = 0;
		this.rulesWarning = 0;
		this.previousOrderId = null;
		this.hasOrderBeenChanged = false;
		this.updatedRuleStatus = [];
		this.orderDetail$
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((orderDetailModel: OrderDetailModel) => {
				this.orderInboxModel = orderDetailModel;
				if (
					this.previousOrderId &&
					this.orderInboxModel &&
					this.previousOrderId !== this.orderInboxModel.id
				) {
					// order has changed from a route.navigation
					this.hasOrderBeenChanged = true;
					// get rules orders when the navigation is from inbox notification
					// well the back-end response is not the same so until the response from the server we always listen
					this.rulesSelected$.pipe(takeUntil(this.atComponentDestroy)).subscribe(rules => {
						this.updateRulesDataFromStorage(rules);
					});
				} else if (!this.previousOrderId && this.orderInboxModel) {
					// assign order id as the actual id.
					this.previousOrderId = this.orderInboxModel.id;
				}
			});
		this.currentUser = this.store.selectSnapshot(s => s.user);

		this.selectedSection$
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((selectedSection: any) => {
				if (selectedSection && selectedSection.path) {
					setTimeout(() => {
						const classes = [
							'rule-' + selectedSection.path.toLowerCase(),
							'multiple-section-' + selectedSection.path.toLowerCase()
						];

						for (let index = 0; index < classes.length; index++) {
							const elements = document.getElementsByClassName(classes[index]);
							if (elements.length) {
								elements[0].scrollIntoView();
								break;
							}
						}
					});

					this.currentSection = selectedSection.path.toUpperCase();
				}
			});
		this.onFieldSelectedListener();
	}

	ngOnInit(): void {
		this.openSubContent(null, null);
		this.canFilterSsr = this.orderInboxModel.hasSsrRules;
		if (!this.data.targets) {
			this.data.targets = { data: null, primary: null };
		}

		this.onRevised$.pipe(takeUntil(this.atComponentDestroy)).subscribe((onRevised: any) => {
			this.getRuleDataBaseOnAction(onRevised, 50);
		});

		this.rulesSelected$.pipe(takeUntil(this.atComponentDestroy)).subscribe((rules: any) => {
			this.updateRulesDataFromStorage(rules);
		});

		this.isRuleRunning$.pipe(takeUntil(this.atComponentDestroy)).subscribe(r => {
			this.runningRules = r;
			this.deferredRuleIndicator = r ? RULES_INDICATOR.INPROCESS : RULES_INDICATOR.NODEFFERED;
		});

		this.rules$.pipe(takeUntil(this.atComponentDestroy)).subscribe(rls => {
			if (rls && rls.rulesLog) {
				this.rulesNotifications = rls.rulesLog;
			}
		});
		this.channels$.pipe(takeUntil(this.atComponentDestroy)).subscribe((channels: any) => {
			if (channels && channels[`orders:${this.orderInboxModel.id}`]) {
				this.onRulesEvents(channels[`orders:${this.orderInboxModel.id}`].events);
			}
		});
		this.onResizeMultiSelectFilter();
	}

	/**
	 * update rules list coming from the server
	 * @param rules
	 */
	updateRulesDataFromStorage(rules: any): void {
		if (rules && rules.violation) {
			const isOnRevised = this.store.selectSnapshot(RulesState.getSelectedOnRevised);
			const v = rules.executedRuleSets.map(x => {
				return { id: x, name: x };
			});
			this.filterOptions = [];
			this.filterOptions = [...v];
			this.onResizeMultiSelectFilter();
			this.setRulesData(rules, isOnRevised);
		}
	}

	/**
	 * set rules data from storage if the order was revised
	 * @param isRevised
	 */
	getRuleDataBaseOnAction(isRevised: boolean, time: number): void {
		setTimeout(() => {
			const rules = this.store.selectSnapshot(RulesState.getOrderRules);
			if (rules && rules.violation) {
				this.setRulesData(rules, isRevised);
			}
		}, time);
	}

	/**
	 *  get screen resolution and set rules filter value depend on that
	 */
	@HostListener('window:resize', ['$event'])
	onResizeMultiSelectFilter(): void {
		const opt = this.filterOptions.map(x => {
			const id = x.id;
			const name = this.nameFilterResize(x.id);
			return { id, name };
		});

		this.filterOptions = [];
		this.filterOptions = [...opt];
		if (this.filterValues.length && this.filterValues.length === 1) {
			const valOpt = this.filterValues.map(v => {
				const id = v.id;
				const name = this.nameFilterResize(v.id);
				return { id, name };
			});
			this.filterValues = [];
			this.filterValues = [...valOpt];
		}
	}

	/**
	 * puts dots on the string depending on the screen resolution
	 * @param name
	 */
	nameFilterResize(name: string): string {
		let rezName = name;
		if (name.length > 30 && window.innerWidth > 1750 && window.innerWidth < 1820) {
			rezName = `${name.substring(0, 29)}...`;
		}
		if (name.length > 20 && window.innerWidth > 1500 && window.innerWidth < 1749) {
			rezName = `${name.substring(0, 19)}...`;
		}
		if (name.length > 14 && window.innerWidth < 1500) {
			rezName = `${name.substring(0, 13)}...`;
		}
		if (window.innerWidth > 1820) {
			rezName = name;
		}
		return rezName;
	}

	/***
	 * set rule info from state management
	 */
	private setRulesData(r: any, isRevised: boolean): void {
		if (isRevised) {
			const rci = this.store.selectSnapshot(RulesState.getRuleCompareInfo);
			if (rci) {
				this.data.rules = r.violation.filter(v => rci.some(rc => rc === v.name));
			}
		} else {
			this.data.rules = r.violation;
		}

		this.filterRules();
		this.updateRuleCheckersAndCounters(r.violation);
	}

	/**
	 * get new rules after force execution
	 */
	getUpdatedRules(): void {
		const { id, documentId, revised } = this.orderInboxModel;
		this.rulesService.getOrderDocumentRules(id, documentId).subscribe(rule => {
			this.store.dispatch(new SetRuleSet(id));
			this.reRunRuleInfo(rule);
		});
		if (revised && this.currentSection === DOCUMENT_RULES_UI_SECTIONS.REVISIONS) {
			this.store.dispatch(new RuleComapateInfo(id));
		}
	}

	/**
	 *	set config and new rules returned by the API
	 * @param rule
	 */
	reRunRuleInfo(rule: any): void {
		const isRunningRules = rule.deferredRuleIndicator === RULES_INDICATOR.INPROCESS;
		this.deferredRuleIndicator = rule.deferredRuleIndicator;
		this.store.dispatch(new UpdatedRuleOrders(rule, this.orderInboxModel));
		this.store.dispatch(new SetIsRunningRules(isRunningRules));
	}

	/**
	 * On any current order related events analyze the action and apply changes to order model.
	 * @param events
	 */
	private onRulesEvents(channels: Array<any>): void {
		const r = channels.find(item => item.event === ORDER_EVENT_TYPE.ORDER_RULES_FORCE_EXECUTION_CI);
		const srrRules = channels.find(
			item => item.event === ORDER_EVENT_TYPE.ORDER_RULES_SSR_RULESREADY
		);

		if (
			channels.length &&
			channels[0].event === ORDER_EVENT_TYPE.ORDER_RULES_CHANGED &&
			channels[0].status === 'new'
		) {
			const { data } = channels[0];
			if (data.user.id !== this.currentUser.id) {
				this.store.dispatch(
					new UpdatedRulelog([
						{
							title: data.violations[0].displayText,
							modifiedBy: data.user.fullName,
							section: data.violations[0].uiSection,
							date: Date.now()
						}
					])
				);
				this.store.dispatch(new UpdatedRuleViolation(data.violations));
				this.store.dispatch(
					new ChangeEventItemOnChannelAction(
						`orders:${this.orderInboxModel.id}`,
						channels[0],
						'orderId'
					)
				);
			}
		}
		if (srrRules) {
			this.getUpdatedRules();
		}

		if (r) {
			const { rules } = r.data;
			this.deferredRuleIndicator = rules.deferredRuleIndicator;
			if (rules.deferredRuleIndicator === RULES_INDICATOR.COMPLETE && this.runningRules) {
				this.getUpdatedRules();
			}
		}
	}

	/**
	 * On Filter rules, filter rules by types selected or unselected..
	 * @param type: RULE_MESSAGE_TYPE
	 */
	onTypeFiltersChange(filter: RULE_MESSAGE_TYPE): void {
		// remove it if already in current filters
		if (filter && this.currentFilters.indexOf(filter) >= 0) {
			this.currentFilters = this.currentFilters.filter(item => item !== filter);
		} else {
			// add it
			this.currentFilters.push(filter);
		}
		this.filterRules();
	}

	/**
	 * Sort rules based on current selections.
	 */
	sortRules(rules: Array<RuleModel>): Array<RuleModel> {
		return rules.sort((a, b) => {
			if (!a.cvSortId) {
				const cvSortId = Number.MAX_SAFE_INTEGER;
				a = {
					...a,
					cvSortId
				};
			}
			if (!b.cvSortId) {
				const cvSortId = Number.MAX_SAFE_INTEGER;
				b = {
					...b,
					cvSortId
				};
			}
			return a.cvSortId - b.cvSortId;
		});
	}

	/**
	 * Filters the rule list based on selected message types, rule set filters, and review status.
	 * Updates the visible rule list and the badge counters (Info, Warning, Error).
	 * Badge counters reflect the filtered rule set and unchecked status, but are not affected by message type filters.
	 */
	filterRules(): void {
		const allRules = this.data?.rules || [];

		// Determine whether ruleSet filters are currently applied
		const isRuleFiltered = this.filterValues.length > 0;

		// Extract the selected ruleSet identifiers for filtering
		const activeFilters = isRuleFiltered ? this.filterValues.map(f => f.id) : [];

		// Initialize the display list and message type counters
		this.rules = [];
		this.rulesInfo = 0;
		this.rulesWarning = 0;
		this.rulesError = 0;

		// Iterate through all rules to evaluate against current filters
		for (const rule of allRules) {
			// Check if rule matches selected ruleSet filters (if any)
			const matchesRuleSet =
				!isRuleFiltered || activeFilters.includes(rule.ruleSetDisplayText);

			// Check if 'view only unchecked' filter is applied and satisfied
			const matchesUnchecked =
				!this.viewOnlyUncheckedRules || rule.status === RULE_STATUS.NOT_REVIEWED;

			// Step 1: Update badge counters
			// Message type filters are NOT applied to counters — we always count all types that match other filters
			if (matchesRuleSet && matchesUnchecked) {
				switch (rule.messageType) {
					case RULE_MESSAGE_TYPE.Info:
						this.rulesInfo++;
						break;
					case RULE_MESSAGE_TYPE.Warning:
						this.rulesWarning++;
						break;
					case RULE_MESSAGE_TYPE.Error:
						this.rulesError++;
						break;
				}
			}

			// Step 2: Add rule to display list only if it matches ALL filters
			const matchesType = this.currentFilters.includes(rule.messageType);

			if (matchesType && matchesRuleSet && matchesUnchecked) {
				this.rules.push(rule);
			}
		}

		// Sort the final list of rules before displaying
		this.rules = this.sortRules(this.rules);
	}

	/**
	 * set filter rules value
	 * @param event
	 */
	public onFilterRulesChange(event: any): void {
		this.filterValues = event.map(x => Object.assign({}, x));
		this.filterRules();
	}

	/**
	 * Returns true if filter is within the current selected filters.
	 * @param filter
	 */
	containsFilter(filter: RULE_MESSAGE_TYPE): boolean {
		return this.currentFilters.indexOf(filter) >= 0;
	}

	/**
	 * On clear filter, remove current type filter.
	 */
	onClearFilters(): void {
		this.onTypeFiltersChange(null);
	}

	/**
	 * Return Info type rules.
	 */
	getInfoRules(): Observable<Array<RuleModel>> {
		const rules = this.data.rules
			? this.data.rules.filter(rule => rule.messageType === RULE_MESSAGE_TYPE.Info)
			: [];
		return of(rules);
	}

	/**
	 * Return Warning type rules.
	 */
	getWarningRules(): Observable<Array<RuleModel>> {
		const rules = this.data.rules
			? this.data.rules.filter(rule => rule.messageType === RULE_MESSAGE_TYPE.Warning)
			: [];
		return of(rules);
	}

	/**
	 * Return Error type rules.
	 */
	getErrorRules(): Observable<Array<RuleModel>> {
		const rules = this.data.rules
			? this.data.rules.filter(rule => rule.messageType === RULE_MESSAGE_TYPE.Error)
			: [];
		return of(rules);
	}

	/**
	 * Return unchecked type rules.
	 */
	toggleViewOnlyUncheckedRules(): void {
		this.viewOnlyUncheckedRules = !this.viewOnlyUncheckedRules;
		this.store.dispatch(new SetUncheckedRules(this.viewOnlyUncheckedRules));
		this.filterRules();
	}

	/**
	 * Return SRR type rules.
	 */
	toggleViewOnlySsrRules(): void {
		this.viewOnlySsrRules = !this.viewOnlySsrRules;
		this.filterRules();
	}

	/**
	 * check if the rule has background proccess
	 */
	isRunningRules(): boolean {
		return this.deferredRuleIndicator === RULES_INDICATOR.INPROCESS;
	}

	/**
	 * Update rule checkers and counters for all uiSections.
	 * @param rules: Array<RuleModel>
	 */
	private updateRuleCheckersAndCounters(allRules: Array<RuleModel>): void {
		Object.keys(DOCUMENT_RULES_UI_SECTIONS).map(uiSection => {
			const rulesNotReviewed = allRules.filter(
				rule =>
					rule.uiSection.toLowerCase().includes(uiSection.toLowerCase()) &&
					rule.status === RULE_STATUS.NOT_REVIEWED
			);
			const section = <DOCUMENT_RULES_UI_SECTIONS>uiSection;
			this.rulesService.setRulesStatusCanSave(
				section,
				!rulesNotReviewed.length,
				rulesNotReviewed.length
			);
		});

		if (this.orderInboxModel.revised) {
			const ruleCompareInfo = this.store.selectSnapshot(RulesState.getRuleCompareInfo);
			const rulesNotReviewedRevised = allRules.filter(
				rule => ruleCompareInfo.includes(rule.name) && rule.status === RULE_STATUS.NOT_REVIEWED
			);
			this.rulesService.setRulesStatusCanSave(
				DOCUMENT_RULES_UI_SECTIONS.REVISIONS,
				!rulesNotReviewedRevised.length,
				rulesNotReviewedRevised.length
			);
		}
	}

	/**
	 * Listen for fields selection
	 */
	private onFieldSelectedListener(): void {
		this.broadcastService.on(UI_FIELD_SELECTED_EVENT, (broadcast: BroadcastEventModel) => {
			const rule = broadcast.event.rule;
			this.onRuleSelected(rule);
			const ruleId = 'rule' + rule.uiSection + rule.displayText.replace(/\s/g, '');
			const element = document.getElementById(ruleId);
			if (element) {
				element.scrollIntoView();
			}
		});
	}

	/**
	 * On create rule event, open the create rule panel.
	 */
	public onCreateRule(): void {
		this.toggleSubPanel(true, SUB_PANEL_TYPE.CREATE_RULE);
	}

	/**
	 * On show notificaiton rule, open the notification rule panel.
	 */
	public onOpenNotificationsRule(): void {
		this.toggleSubPanel(true, SUB_PANEL_TYPE.VIEW_RULE_NOTIFICATIONS);
	}
	/**
	 * Determines if current order can create rules
	 */
	canCreateRule(): boolean {
		if (!this.orderInboxModel) {
			return false;
		}
		const { stateEnum } = this.orderInboxModel;
		return (
			stateEnum !== ORDER_STATE.REJECTED &&
			stateEnum !== ORDER_STATE.APPROVED &&
			this.currentSection !== DOCUMENT_RULES_UI_SECTIONS.REVISIONS
		);
	}

	/**
	 * open rule set windows
	 */
	openRuleSet(): void {
		const { id, documentId } = this.orderInboxModel;
		this.broadcastService.broadcast({
			name: RULE_SET_EVENT,
			event: {
				isOpen: true,
				order: {
					id,
					documentId
				}
			}
		});
	}

	/**
	 * On update rule status event, send the notification result.
	 */
	onRuleUpdated($event: any): void {
		if (!this.viewOnlyUncheckedRules) {
			this.store.dispatch(
				new UpdatedRuleStatus({
					ruleName: $event.ruleName,
					status: $event.ruleStatus
				})
			);
			this.filterRules();
		} else {
			clearTimeout(this.updateRulesFunctionId);

			this.updatedRuleStatus.push({
				ruleName: $event.ruleName,
				ruleStatus: $event.ruleStatus
			});

			// If no new rule updates in 500 milliseconds, updates rules state
			this.updateRulesFunctionId = setTimeout(() => {
				this.store.dispatch(new UpdatedMultipleRuleStatus(this.updatedRuleStatus)).subscribe(() => {
					this.filterRules();
					this.updatedRuleStatus = [];
				});
			}, 500);
		}

		this.broadcastService.broadcast({
			name: UPDATE_REJECTED_SUMMARY,
			event: {}
		});
	}

	/**
	 * On rule selected event, set the rule as currently active.
	 */
	onRuleSelected(rule: RuleModel): void {
		this.selectedRule = rule;
		this.updateEvent.emit(rule);
	}

	/**
	 * On Add comment click.
	 */
	onAddComment(rule: RuleModel): void {
		this.subPanelSelectedRule = rule;
		this.toggleSubPanel(true, SUB_PANEL_TYPE.ADD_COMMENT);
	}

	/**
	 * On Add comment from view click.
	 */
	onAddCommentFromView(rule: RuleModel): void {
		this.toggleSubPanel(false, SUB_PANEL_TYPE.VIEW_COMMENTS_AND_STIPS, () => {
			this.subPanelSelectedRule = rule;
			this.toggleSubPanel(true, SUB_PANEL_TYPE.ADD_COMMENT);
		});
	}

	/**
	 * On Delete comments click.
	 */
	onDeleteComments($event: any): void {
		const { id, documentId } = this.orderInboxModel;
		this.rulesService
			.deleteComments(id, documentId, this.subPanelSelectedRule.name, $event)
			.subscribe({
				complete: () => {
					this.store.dispatch(
						new DeleteComementRule({
							ruleName: this.subPanelSelectedRule.name,
							deletedNotes: $event
						})
					);
					this.showNotification('Comments Deleted');
					this.toggleSubPanel(false);
				},
				error: err => {
					this.showNotification('Failed to delete comments.');
					this.toggleSubPanel(false);
				}
			});
	}

	/**
	 * On Delete stips event.
	 */
	onDeleteStips($event: any): void {
		const { id, documentId } = this.orderInboxModel;
		this.rulesService
			.deleteStips(id, documentId, this.subPanelSelectedRule.name, $event)
			.subscribe({
				complete: () => {
					this.store.dispatch(
						new DeleteStipsRule({
							ruleName: this.subPanelSelectedRule.name,
							deletedStips: $event
						})
					);
					this.showNotification('Stips Deleted');
					this.toggleSubPanel(false);
				},
				error: err => {
					this.showNotification('Failed to delete stips.');
					this.toggleSubPanel(false);
				}
			});
	}

	/**
	 * On Add stip from view click.
	 */
	onAddStipFromView(rule: RuleModel): void {
		this.toggleSubPanel(false, SUB_PANEL_TYPE.VIEW_COMMENTS_AND_STIPS, () => {
			this.subPanelSelectedRule = rule;
			this.toggleSubPanel(true, SUB_PANEL_TYPE.ADD_STIP);
		});
	}

	/**
	 * On Rule successfully created
	 */
	onRuleCreated($event: RuleModel | boolean, success: boolean): void {
		if (success) {
			this.showNotification('Rule created');
		} else {
			this.showNotification('Rule creation failed');
		}
		this.toggleSubPanel(false);

		if (this.currentSection === DOCUMENT_RULES_UI_SECTIONS.PHOTOREVIEW) {
			this.emitRuleCreatedEvent();
		}
	}

	/**
	 * Emit created rule event
	 */
	private emitRuleCreatedEvent(): void {
		this.broadcastService.broadcast({
			name: CREATED_RULE_EVENT,
			event: {}
		});
	}

	/**
	 * On Comment successfully or failed
	 */
	onCommentAdded($event: RuleCommentModel, success: boolean): void {
		if (success) {
			this.showNotification('Comment posted');
		} else {
			this.showNotification('Comment post failed');
		}
		this.toggleSubPanel(false);
	}

	/**
	 * On Stip successfully or failed
	 */
	onStipAdded($event: RuleStipModel, success: boolean): void {
		if (success) {
			const { id, documentId } = this.orderInboxModel;
			this.rulesService
				.updateRuleStatus(id, documentId, this.subPanelSelectedRule.name, RULE_STATUS.FAILED)
				.subscribe(
					() => {
						// on the background reject the rule
						const status = RULE_STATUS.FAILED;
						this.subPanelSelectedRule = {
							...this.subPanelSelectedRule,
							status
						};
						this.store.dispatch(
							new UpdatedRuleStatus({
								ruleName: this.subPanelSelectedRule.name,
								status: RULE_STATUS.FAILED
							})
						);
						this.toggleSubPanel(false);
					},
					error => this.toggleSubPanel(false)
				);
			this.showNotification('Stip created');
		} else {
			this.showNotification('Stip creation failed');
		}
	}

	/**
	 * On View comment(s) click.
	 */
	onViewComments(rule: RuleModel): void {
		this.subPanelSelectedRule = rule;
		this.viewCommentsMode = VIEW_COMMENTS_MODE.COMMENTS;
		this.toggleSubPanel(true, SUB_PANEL_TYPE.VIEW_COMMENTS_AND_STIPS);
	}

	/**
	 * On View stips click.
	 */
	onViewStips(rule: RuleModel): void {
		this.subPanelSelectedRule = rule;
		this.viewCommentsMode = VIEW_COMMENTS_MODE.STIPS;
		this.toggleSubPanel(true, SUB_PANEL_TYPE.VIEW_COMMENTS_AND_STIPS);
	}

	/**
	 * On Add Stip click.
	 */
	onAddStip(rule: RuleModel): void {
		this.subPanelSelectedRule = rule;
		this.toggleSubPanel(true, SUB_PANEL_TYPE.ADD_STIP);
	}

	/**
	 * Show/Hide Rule Add comment component
	 * @param open: boolean
	 */
	toggleSubPanel(
		open: boolean,
		panelType: SUB_PANEL_TYPE = null,
		callback: any = null
	): void {
		if (open) {
			this.rulesContainer.nativeElement.scrollIntoView(false);

			this.activeSubPanel = panelType;
			this.currentTransitionState = TRANSITION_STATE.IS_OPEN;
		} else {
			this.currentTransitionState = TRANSITION_STATE.IS_CLOSE;
			this.activeSubPanel = null;
			this.subPanelSelectedRule = null;
		}
		if (callback) {
			setTimeout(() => callback(), 400);
		}
	}

	/**
	 * Close all when the element is destroyed
	 * in case a Sub Component remains visible
	 */
	ngOnDestroy(): void {
		// Globally Destroy anything attached to it
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
